import { css } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { FlexBox } from '@fable/components'
import { StatsHeaderTitle } from '../stats_header'
import { getRatingResult } from '../../lib/utils'
import { RatingsGrid } from './RatingsGrid'

export const RatingsShareCard = () => {
  const [stats, year, yearStatus] = useStats((s) => [
    s.stats,
    s.year,
    s.yearStatus,
  ])
  const { averageRatingText, averageRatingUnit } = getRatingResult(stats)

  return (
    <FlexBox
      className={css`
        width: 352px;
        padding: 16px;
        padding-bottom: 20px;
      `}
      flexDirection="column"
    >
      <StatsHeaderTitle
        top="Average rating"
        middle={averageRatingText}
        bottom={
          <>
            {averageRatingUnit}
            <span
              className={css`
                margin-left: 4px;
                opacity: 0.5;
              `}
            >
              {yearStatus === 'past' ? `in ${year}` : 'so far this year'}
            </span>
          </>
        }
      />
      <RatingsGrid animate={false} />
    </FlexBox>
  )
}
